import { clsx } from 'clsx';
import { extendTailwindMerge } from 'tailwind-merge';
/**
 * tailwind-merge must know our custom fontSize tokens (h1/h2/h3/body/micro from the preset) so it
 * classifies `text-body`, `text-micro`, etc. as FONT-SIZE utilities - not text COLOR. Without this,
 * tailwind-merge treats the unknown `text-<token>` as a color and, being last-wins, silently drops a
 * variant's `text-white` (e.g. a primary Button with `className="text-body ..."` rendered with dark,
 * near-invisible text). Registering them here fixes it for every component at once and prevents the
 * per-page regressions we kept chasing.
 */
const twMerge = extendTailwindMerge({
    extend: {
        classGroups: {
            // MUST list every custom size in the preset's `fontSize`. `hero` and `section` were added to
            // the preset later and missed here, which silently reintroduced the exact bug this block was
            // written to fix. `font-size-tokens.test.ts` now derives the expected list from the preset so
            // the two cannot drift again.
            'font-size': [{ text: ['hero', 'h1', 'h2', 'h3', 'section', 'body', 'micro'] }],
        },
    },
});
/** Tailwind-aware className combiner used by every component. */
export function cn(...inputs) {
    return twMerge(clsx(inputs));
}
//# sourceMappingURL=cn.js.map